import script from "./WidgetFormBody.vue?vue&type=script&setup=true&lang=ts"
export * from "./WidgetFormBody.vue?vue&type=script&setup=true&lang=ts"

import "./WidgetFormBody.vue?vue&type=style&index=0&id=66637c66&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/.pnpm/vue-loader@17.3.1_@vue+comp_8f2c4c49f6fda9a4fff749d98711c87c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66637c66"]])

export default __exports__